import React from "react";

const Interests = ({ user }) => {
  return (
    <div className="space-y-1">
      <label className="text-white capitalize">Interests</label>
      <div className="flex flex-wrap gap-2">
        {user?.preferences?.interests?.map((interest, index) => (
          <span
            key={index}
            className="bg-amber-500 text-black rounded-lg px-2 py-1"
          >
            {interest || ""}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Interests;
